module.exports = __webpack_public_path__ + "images/da06fb1b5b0cc4a53c0b89d6b08b7460.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters07.jpg
// module id = ./webpack/assets/img/diaryofanant-characters07.jpg
// module chunks = 0